import React, { useMemo } from 'react';

import { ListContext } from '../ListContext';

export default function (WrappedComponent) {
	/*

		Doesn't accept a query
		Doesn't provide an operationName (of the query)
		Doesn't set up two states of variables (only requires one)
		Doesn't need to provide loading states

		Accepts items directly and passes them through
		No state used (this will be used with withListActionsFrontEnd,
		which handles that aspect)

	*/

	const ReturnedComponent = function ({
		items,
		...otherProps
	}) {
		// Set up helpful loading statuses
		// const loadingInitial = false;
		// const loadingMore = false;
		// const loading = false;
		const context = useMemo(() => ({

			count: items ? items.length : null,
			// loading,
			// loadingInitial,
			// loadingMore,
			items: !items ? null : items,
			loadingInitial: !items,

		}), [items]);

		return (
			<ListContext.Provider value={context}>
				<WrappedComponent {...otherProps} />
			</ListContext.Provider>
		);
	};

	return ReturnedComponent;
}

